const LIFE_INSURANCE_ENDPOINTS = {
  lifeInsurance: "/frontend/life-insurance/quote",
  DownloadlifeInsurancePDF:"/frontend/generate-quote-pdf",
  calculatorAnalytics:"/frontend/calculator-analytics/track",
};

export default LIFE_INSURANCE_ENDPOINTS;